import { lazy } from 'react';

export const HeanuserList = lazy(() => import('./page-list'));

